import '../../resources/css/common/ModalPickupList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reactFormatter } from 'react-tabulator';
import ModalPickList from '../../components/common/ModalPickList';
 
let componentProps = null;
 
const checkEnabled = (e, cell, isChecked, isMultiChoose) => {
  e.stopPropagation();
  if (cell) {
    if (isChecked) {
      if (!isMultiChoose) {
        const rows = cell.table.getRows();
 
        // check has choose other value
        rows.forEach(row => {
          let checkCell = row._row.getCell('PICK_CHECKED');
          if (checkCell.getValue()) {
            checkCell.setValue(0);
            row.deselect();
          }
        });
      }
 
      cell.setValue(1);
      cell.row.component.select()
    } else {
      cell.setValue(0);
      cell.row.component.deselect()
    }
  }
}
 
const EnabledBtn = (props) => {
  let iconContent;
  const cellRef = componentProps.isReadonly ? null : props.cell._cell;
  if (props.cell._cell.value) {
    iconContent = <span className='icon-btn-checkbox-p' onClick={(e) => checkEnabled(e, cellRef, false, props.isMultiChoose)}></span>;
  } else {
    iconContent = <span className='icon-btn-checkbox-n' onClick={(e) => checkEnabled(e, cellRef, true, props.isMultiChoose)}></span>;
  }
 
  return <div className='area-enabled-icon'>{ iconContent }</div>
}
 
class ModalPickGroup extends Component {
 
  constructor(props) {
    super(props);
 
    componentProps = props;
  }  
 
  // open pick name
  modalName = 'PickGroup'
 
  // open pick title
  modalTitle = 'Select Group'
 
  // for pick up back data key
  pickUniqueId = 'seq,name'
 
  // pick is multi choose or one choose
  isMultiChoose = this.props.isMultiChoose === false ? false : true
 
  // open pick list columns
  columns = [
    { title: "", field: "PICK_CHECKED", width: 60, formatter: reactFormatter(<EnabledBtn isMultiChoose={ this.isMultiChoose } />) },
    { title: "ID", field: "seq", width: 70 },
    { title: "Group Name", field: "name", /*headerFilter: 'input'*/ },
    { title: "Country", field: "country", /*headerFilter: 'input'*/ },
    { title: "City", field: "city", /*headerFilter: 'input'*/ },
    { title: "Latitude", field: "latitude", /*headerFilter: 'input'*/ visible: false },
    { title: "Longitude", field: "longitude", /*headerFilter: 'input'*/ visible: false}
  ]
 
  render() {
    const { selectMultiCol, groupListByOrg } = this.props;
 
    return (
      <div className='area-pick-organization'>
          <ModalPickList
            modalName={ this.modalName }
            modalTitle={ this.modalTitle }
            pickUniqueId={ this.pickUniqueId }
            isMultiChoose={ this.isMultiChoose }
            selectMultiCol={ selectMultiCol }
            columns={ this.columns }
            dataList={ groupListByOrg }
          >
          </ModalPickList>
      </div>
    )
  }
}
 
const mapStateToProps = (state, ownProps) => {
  return {
    groupListByOrg: state.modelReducers.groupListByOrg,
    selectMultiCol: ownProps.selectMultiCol
  }
}
 
export default connect(
  mapStateToProps,
  { }
)(ModalPickGroup)

